export const UPDATE_WORKSPACE = 'UPDATE_WORKSPACE';
export const WORKSPACE_RESET_STATE = 'WORKSPACE_RESET_STATE';
